import * as moment from "moment";
import "moment/locale/cs";
/*moment.locale("en", {
  week: {
    dow: 1
  }
});
moment.locale("cs");
*/
export let Svatky = {
  velikonocni_pondeli: [
    "22.4.2019",
    "13.4.2020",
    "5.4.2021",
    "18.4.2022",
    "10.4.2023",
    "1.4.2024",
    "21.4.2025",
    "6.4.2026",
    "29.3.2027"
  ],
  statni_svatky: ["1.1.", "8.5.", "5.7.", "6.7.", "28.9.", "28.10.", "17.11."],
  nastavCas: function(pomMonent, cas) {
    return moment(pomMonent.format("YYYY-MM-DD") + " " + cas);
  },
  /*slouzi napr pro nastaveni dalsiho pondeli kdyz je vikend */
  nastavDalsiDenVtydnu: function(pomMonent, denVtydnu) {
    //Lc.f("nastavDalsiDen");
    let d = pomMonent.clone().weekday(denVtydnu);
    //Lc.log(d.format());
    return d;
  },
  nastavDalsiDen: function(pomMonent, pocetDni = 1) {
    let m = pomMonent.clone();
    m.add(pocetDni, "days");

    let d = moment(m.format("YYYY-MM-DD HH:mm"));

    return d;
  },
  overVikend: function(pomMonent) {
    /*
    Lc.f("overVikend");
    Lc.log("datum", pomMonent.format());
    Lc.log("res", pomMonent.isoWeekday());
    Lc.log("res", pomMonent.isoWeekday() > 5 ? true : false);
    */
    return pomMonent.clone().isoWeekday() > 5 ? true : false;
  },
  overSvatek: function(pomMonent) {
    //Lc.f("overSvatek");

    let denMesic = pomMonent.clone().format("D.M.");
    let denMesicRok = pomMonent.clone().format("D.M.YYYY");
    if (this.statni_svatky.indexOf(denMesic) > -1) {
      return true;
    } else if (this.velikonocni_pondeli.indexOf(denMesicRok) > -1) {
      return true;
    }

    return false;
  },
  vratVse: function(dnes = false) {
    return new Promise(function(resolve) {
      let dnesMoment;
      //moment.locale("cs");

      if (dnes == false) {
        dnesMoment = moment();
      } else {
        dnesMoment = moment(dnes);
      }

      let zitraMoment = Svatky.nastavDalsiDen(dnesMoment, 1);
      let data = { dnesSvatek: false, zitraSvatek: false };

      data.zitraMoment = zitraMoment;
      data.zitraSvatek = Svatky.overSvatek(data.zitraMoment);
      data.dnesSvatek = Svatky.overSvatek(dnesMoment);
      data.dnesMoment = dnesMoment;

      data.weekDay = dnesMoment.isoWeekday();
      data.dnesVikend = Svatky.overVikend(data.dnesMoment);
      data.zitraVikend = Svatky.overVikend(data.zitraMoment);
      //data.dnesVikend = data.weekDay > 5 ? true : false;
      //data.zitraVikend = data.weekDay + 1 > 5 ? true : false;
      return resolve(data);
    });
  }
};
